/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-week-end-9': {
    width: 31,
    height: 37,
    viewBox: '0 0 31 37',
    data: '<path pid="0" class="st0" d="M30 8.5L16.3.2c-.5-.3-1.2-.3-1.7 0L.8 8.5c-.5.3-.8.8-.8 1.4v24.7c0 .9.7 1.7 1.7 1.7h27.5c.9 0 1.7-.7 1.7-1.7V9.9c-.1-.6-.4-1.1-.9-1.4M19.2 33h-7.7V22.6h7.7V33zm8.3 0h-4.9V20.9c0-.9-.7-1.7-1.7-1.7h-11c-.9 0-1.7.7-1.7 1.7V33H3.3V10.8l12.1-7.2 12.1 7.2V33z"/>'
  }
})
